var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading text-center"},[_c('div',{staticClass:"loader"}),_c('p',[_vm._v(_vm._s(_vm.$t('App.Loading')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }